<template>
  <div class="app-wrapper" :class="classObj">
    <div class="main-container" style="margin-left: 0;">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import bottomNav from "../components/website/bottomNav";
import ResizeMixin from "./mixin/ResizeHandler";

export default {
  name: "layout-phone",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    bottomNav
  },
  data() {
    return {
      bottomNavShow: true,
      bottomNavList: [
        {
          name: "首页",
          icon: "el-icon-s-goods",
          selected: true,
          path: "/"
        },
        {
          name: "个人中心",
          icon: "el-icon-user-solid",
          selected: false,
          path: "/user"
        }
      ]
    };
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout-phone.vue